/**
 * Resolves or rejects a Promise from an Axios success callback.
 * Guards against a missing response (e.g. when a response interceptor returns undefined).
 */
export const handleAxiosResponse = (response, resolve, reject) => {
  if (response == null || typeof response.status !== 'number') {
    reject(new Error('Request failed: no response'))
    return
  }
  if (response.status !== 200) {
    reject(new Error(response.statusText || `HTTP ${response.status}`))
    return
  }
  resolve(response.data)
}

export const isUnauthorizedAxiosError = (error) => {
  return error?.response?.status === 401
}
